module Meevo.Plugins.MerchantAccounts {
    export class ReassignPaymentAccountsModalController {
        public toMerchantAccountId: string;

        static $inject = [
            'merchantAccounts',
            'meevo.components.modal.ModalService',
        ];

        constructor(
            public merchantAccounts: Meevo.Model.MerchantAccount[],
            private modalService: Meevo.Components.Modal.IModalService
        ) {
            this.initialize();
        }

        private initialize() {
            // if only 1 merchant account exists, pre-select it
            if (this.merchantAccounts.length === 1) {
                this.toMerchantAccountId = this.merchantAccounts[0].id;
            }            
        }

        private isValid(): boolean {
            return true;
        }

        continue() {
            if (!this.isValid()) {
                return;
            }

            this.close(this.toMerchantAccountId);
        }

        close(response) {
            this.modalService.hideWithResponse(response);
        }

        cancel() {
            this.modalService.hide();
        }
    }

    angular.module("meevo.plugins.merchantAccounts")
        .controller("meevo.plugins.merchantAccounts.ReassignPaymentAccountsModalController", ReassignPaymentAccountsModalController);
}
